import { AppAlert } from '@components/antd';
import { useAppBanner } from './hooks/use-app-banner';
import SuspensionPaymentDueModal from '../../modal/modal-suspension-payment';
import { Trans } from 'react-i18next';

export const SuspensionWarningBanner = () => {
  const { remainingDays, paymentModal } = useAppBanner();
  return (
    <AppAlert
      showIcon
      type="error"
      message={
        <>
          <p>
            <Trans
              i18nKey="your_account_will_get_suspended_in_day_please_fix_this"
              components={[
                <span
                  key="fix-link"
                  className="cursor-pointer text-amber-700"
                  onClick={paymentModal.handleOpen}
                ></span>,
              ]}
              values={{ day: remainingDays }}
              count={remainingDays}
            />
          </p>
          <SuspensionPaymentDueModal paymentModal={paymentModal} />
        </>
      }
    />
  );
};
